
import Vue from 'vue'

export default Vue.extend({
  name: 'Loader',
  props: {
    color: {
      type: String,
      default: '#2A59DB'
    }
  }
})
